/**
 * automationTypes.js
 *
 * Canonical string enum of automation step types. Extracted from the legacy
 * InstaCommentToDMOtherAutomations.js so live code (InstagramDMPreview) can
 * reference it without pulling in the surrounding dead-chain UI components.
 */

export const automationTypes = {
  REPLY_TO_COMMENTS: "reply-to-comments",
  REQUEST_MOBILE_NUMBER: "phoneNumber",
  REQUEST_TO_FOLLOW: "followCheck",
  REQUEST_EMAIL: "email",
  FOLLOW_UP: "followUp",
};
